import { render, staticRenderFns } from "./Tela.vue?vue&type=template&id=c450792a&"
import script from "./Tela.vue?vue&type=script&lang=js&"
export * from "./Tela.vue?vue&type=script&lang=js&"
import style0 from "./Tela.vue?vue&type=style&index=0&id=c450792a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports